import React from 'react';
import Link from 'gatsby-link';
import Feedback from '../components/UI/Feedback';
import { createApolloFetch } from 'apollo-fetch';
import { Route, Redirect } from "react-router-dom";

import RenderSurvey from '../components/UI/Survey';
//import { survey } from '../data/AVIS_CUSTOMER_CARE_CX';

const survey_h_id = 'AVIS_SALES_SIGNATURES_H_CX';
const survey_s_id = 'AVIS_SALES_SIGNATURES_S_CX';
const survey_n_id = 'AVIS_SALES_SIGNATURES_N_CX';


const fetch = createApolloFetch({
    //uri: 'http://localhost:3000/graphql',
    uri: 'https://www.mrmapp.com/graphql',
});

const makeid = () => {
  let text = "";
  const possible = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
  for (let i = 0; i < 5; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text + '-' + Date.now().toString();
}

class SurveyPage extends React.Component {
    constructor (props) {
        super(props);
        this.state = {loading: true, survey: null, completed: false, model: null};
        this.loadSurvey = this.loadSurvey.bind(this);
        this.session_id = makeid();
        this.saveCounter = 0;
        this.onSubmit = this.onSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onPage = this.onPage.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    onPage (page, model, direction) {
        this.model = {...model};
        model[`page_${page}_timestamp`] = new Date();
        model.completed = false;
        model.page = page;
        this.saveData(model, false);
    }

    saveData(model, redirect) {
        if (redirect)
          this.setState({loading: true});
        this.saveCounter++;
        model.session_id = model.session_id ?  model.session_id[0] !== this.session_id ? [this.session_id, ...model.session_id] : model.session_id : [this.session_id];
        model.save_stage = this.saveCounter;
        model.agent_id = this.props.match.params.agent_id;
        model.emotion = this.props.match.params.emotion;
        console.log(model);
        fetch({
            query: `
                mutation ( $model: cxModelTypeInput!, $survey_id: String!, $respondent_id: String ) {
                    cxSurveyUpdate (survey_id: $survey_id, respondent_id: $respondent_id, model: $model)  {
                        model
                        saved
                    }
                }`,
            variables: {
                model: {data: model},
                survey_id: this.props.match.params.emotion === 'h' ? survey_h_id : this.props.match.params.emotion === 's' ? survey_s_id : survey_n_id,
                respondent_id: null
            }
        }).then(res => {
            console.log(res.data);
            if (redirect) {
                this.setState({loading: false});
                this.props.history.push('/thankyou');
            }
        }).catch(error => {
            console.error(error);
          //  this.saveData(model, true);
        });
    }

    onSubmit (model) {
        this.setState({saving: true});
        model.complete_timestamp = new Date();
        model.completed = true;
        model.page = null;
        this.saveData(model, true);
    }

    onCancel () {
        model = this.model;
        if (model) {
            model.cancel_timestamp = new Date();
            model.cancelled = true;
            this.saveData(model, false);
        }
        this.props.history.goBack();
    }

    loadSurvey (props) {
        fetch({
            query: `
                query ( $survey_id: String!, $respondent_id: String ) {
                    cxSurveyFind (survey_id: $survey_id, respondent_id: $respondent_id)  {
                        survey
                        completed
                        model
                    }
                }`,
            variables: {
                survey_id: this.props.match.params.emotion === 'h' ? survey_h_id : this.props.match.params.emotion === 's' ? survey_s_id : survey_n_id,
                respondent_id: null
            }
        }).then(res => {
            console.log(res);
            if (res.data) {
              this.setState({loading: false, survey: res.data.cxSurveyFind.survey, model: res.data.cxSurveyFind.model, completed: res.data.cxSurveyFind.completed });
              const model = res.data.cxSurveyFind.model ? res.data.cxSurveyFind.model : {};
              model[`page_0_timestamp`] = new Date();
              model.completed = false;
              model.page = 0;
              this.saveData(model, false);
            }
        }).catch(error => {
            console.error(error);
            //this.loadSurvey(props);
        });
        //this.setState({loading: false, survey: survey});
    }

    componentDidMount (props) {
        this.loadSurvey(props);
    }

    render () {
        return (
            <div style={{width: '100%', alignItems: 'center'}}>
                <div style={{padding: '20px 40px 20px 30px', margin: '140px 0px 100px 0px', maxWidth: 600, width: '90%', textAlign: 'center', display: 'inline-block', backgroundColor: 'rgba(0, 0, 0, 0.7)'}}>
                  {!this.state.completed && this.state.loading && <Feedback note={'Loading...'} icon={'loading'}/>}
                  {!this.state.completed && !this.state.loading &&
                    <RenderSurvey
                        model={this.state.model}
                        survey={this.state.survey}
                        onSubmit={this.onSubmit}
                        onPage={this.onPage}
                        onCancel={this.onCancel}
                        {...this.props}
                    />}
                  {this.state.completed && <Feedback note={'Your survey response has already been recorded.'} icon={'star-o'}/>}
                </div>
            </div>
        );
    }
}


export default SurveyPage;



// WEBPACK FOOTER //
// ./src/pages/survey.js